import React from 'react'

const InfoInsulation = () => {
  return (
    <div className='content-text'>
        As you click on the Insulation check box, you will be asked to choose if you wish to add it on roof only or full building. Insulation is a non-visual addition to the building and will only reflect in the price summary.
    </div>
  )
}

export default InfoInsulation